import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { IconStayforlong } from '@s4l/icons/IconStayforlong'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import Image from '../../Atoms/Image'
import styles from './styles.module.css'

function AboutUs() {
  const { i18n } = useS4LContext()

  return (
    <div className={styles.container}>
      <div className={styles.containerText}>
        <IconStayforlong className={styles.logo} />
        <Typography as="p" variant="body" size="l">
          {i18n.formatMessage({ id: 'global.about-us' })}
        </Typography>
        <Button
          variant="outlined-rounded"
          as="a"
          size="medium"
          href="/the-brand/home"
          trailingIcon={<IconArrowRight />}
        >
          {i18n.formatMessage({ id: 'support.about-us' })}
        </Button>
      </div>
      <div className={styles.containerImage}>
        <Image
          alt={i18n.formatMessage({ id: 'support.about-us' })}
          width="100%"
          height="100%"
          layout="cover"
          loading="lazy"
          src="https://static.stayforlong.com/web/images/home_v2-about-us/about-us.webp"
          srcSet={[
            'https://static.stayforlong.com/web/images/home_v2-about-us/about-us.webp',
            'https://static.stayforlong.com/web/images/home_v2-about-us/about-us_2x.webp',
          ]}
          className={styles.image}
        />
      </div>
    </div>
  )
}

AboutUs.displayName = 'AboutUs'
export default withErrorBoundary(AboutUs)
